import { observable } from 'mobx';

export class RequestModel {
  @observable refresh: Promise<boolean>;

  pendingRequests: number = 0;
}